<template>
  <div class="shade">
    <div class="shade-close">
      <img src="/static/bytx/public/welfare_detail_share_close.svg" @click="close">
    </div>
    <div class="shade-swipe">
      <div class="shade-swipe-pre" v-show="banners.length > 1">
        <img class="shade-swipe-pre-img" src="/static/bytx/public/welfare_detail_share_left.svg" alt=""
        @click="prePage">
      </div>
    <div class="shade-swipe-wrap">
      <van-swipe class="my-swipe" :autoplay="3000"  :show-indicators="false" ref="swipe">
        <van-swipe-item v-for="(item,i) in banners" :key="i">
          <a href="#">
            <img :src="item.imgs" alt="">
          </a>
        </van-swipe-item>
      </van-swipe>
      <div class="shade-swipe-wrap-text">
        <div class="shade-swipe-wrap-text-wrap">
          <span>献爱心后可联系助手获得作品原图/感恩好礼</span>
        </div>
      </div>
    </div>
      <div class="shade-swipe-next" v-show="banners.length > 1">
        <img class="shade-swipe-next-img" src="/static/bytx/public/welfare_detail_share_right.svg" alt=""
             @click="nextPage">
      </div>
    </div>
    <div class="shade-text">
      <img src="/static/bytx/public/welfare_detail_share_quote_1.svg" alt="">
      <span>献出一份爱，助力血液及肿瘤家庭行至未来</span>
      <img src="/static/bytx/public/welfare_detail_share_quote_2.svg" alt="">
    </div>
    <div class="shade-desc">
      <p>{{ imgObj.title }}</p>
      <p>{{ imgObj.author }}</p>
      <p>{{ imgObj.desc }}</p>
    </div>
    <div class="shade-bot" @click="go">
      <img src="/static/bytx/public/welfare_detail_donate_btn.svg">
    </div>
  </div>
</template>

<script>
import Interface from "../../../../util/interface";
import {LocationHref} from '@/util/common'

export default {
  name: "shade",
  props: {
    imgObj: {
      type: Object,
      default: () => {
        return {}
      }
    },
    shadeShow: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      banners: [],
    }
  },
  created() {

  },
  methods: {
    close() {
      this.$emit('close')
    },
    go() {
      LocationHref(Interface.url.show_love_url)
      Interface.footPrint(42,this.imgObj.id,0,"点击爱心集市详情页献爱心按钮")
    },
    init(id) {
      this.banners = []
      Interface.getData('get',Interface.public.detail + id).then((res) => {
        if (res.code == 0) {
          this.banners.push(res.data)
          // console.table(this.banners)
        }
      })
    },
    prePage() {
      this.$refs.swipe.prev()
    },
    nextPage() {
      this.$refs.swipe.next()
    }
  },
  watch: {
    imgObj: {
      handler: function (val){
        if (val) {

        }
      },
      immediate: true,
      deep: true
    },
    shadeShow: {
      handler: function (val){
        console.log('val===', val)
        if (val) {
          this.init(this.imgObj.id)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .shade{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: rgba(242,242,242,0.9500);
    z-index: 10;
    overflow: auto;
    &-close{
      margin-top: 22px;
      text-align: right;
      img{
        width: 32px;
        height: 32px;
        margin-right: 20px;
      }
    }
    &-swipe{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      position: relative;
      margin-top: 10px;
      height: 420px;
      &-wrap{
        position: relative;
        width: auto;
        height: inherit;
        .my-swipe{
          width: 335px;
          height: 420px;
          img{
            width: 100%;
            height: 420px;
          }
        }
        &-text{
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          height: 420px;
          width: 335px;
          background: transparent;
          &-wrap{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 275px;
            height: 42px;
            line-height: 42px;
            background: rgba(0,0,0,0.6000);
            border-radius: 6px;
            text-align: center;
            span{
              font-size: 13px;
              font-family: HarmonyOS_Sans_SC;
              color: #FFFFFF;
              line-height: 18px;
            }
          }
        }
      }
      &-pre{
        width: 20px;
        height: 60px;
        background: rgba(255,255,255,0.1000);
        text-align: center;
        &-img{
          width: 100%;
          height: 100%;
        }
      }
      &-next{
        width: 20px;
        height: 60px;
        background: rgba(255,255,255,0.1000);
        &-img{
          width: 100%;
          height: 100%;
        }
      }
    }
    &-text{
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 335px;
      height: 40px;
      margin: 0 auto;
      span{
        font-size: 13px;
        font-family: HarmonyOS_Sans_SC;
        color: #818181;
      }
      img{
        width: 22px;
        height: 15px;
      }
    }
    &-desc{
      text-align: center;
      font-family: PingFangSC-Medium, PingFang SC;
      p:nth-child(1){
        margin-top: 16px;
        font-size: 15px;
        font-weight: 500;
        color: #222222;
        line-height: 21px;
      }
      p:nth-child(2){
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8D8D8D;
        margin-top: 6px;
        line-height: 17px;
      }
      p:nth-child(3){
        width: 323px;
        margin: 0 auto;
        margin-top: 10px;
        font-size: 13px;
        font-weight: 400;
        color: #5C5C5C;
        text-align: left;
        line-height: 20px;
      }
    }
    &-bot{
      width: 100%;
      height: 118px;
      padding-top: 26px;
      text-align: center;
      background: rgba(242,242,242,0.9500);
      img{
        width: 136px;
        height: 58px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/community/welfare-zone/component/shade.vue